<template>
  <div class="preview" v-if="isShow">
    <div class="entery_title">
      <div class="line"></div>
      <div class="base_title">预览</div>
      <div class="fuwenben">（鼠标在手机区域内滚动可下滑更多内容）</div>
    </div>

    <div class="preview_phone">
      <img src="../../../assets/img/web/yulan.png"/>
      <div class="preview_phone_content">
        <el-scrollbar class="prdsadasdsa">
          <img class="preview_phone_content_img" v-if="arr[2].obj.image" :src="arr[2].obj.image"/>
          <div class="introduction">
            <div class="introduction_title">
              <img class="titleIcon" src="../../../assets/img/web/qiyejianjieS.png"/>
              企业简介
            </div>
            <img class="introductionUrl_img" :src="ruleForm.entDescUrl"/>
            <div class="introduction_text">{{ruleForm.entDescContent}}</div>
          </div>
          <div class="bussinessGood" v-if="itemShow">
            <div class="introduction_title">
              <img class="titleIcon" src="../../../assets/img/web/qiye.png"/>
              企业产品
            </div>
            <div class="bussinessGood_imgs">
              <template v-for="(item, index) in dataList">
                <div class="bussinessGood_imgs_item" v-if="item.id" :key="index">
                  <div class="bussinessGood_imgs_item_img">
                    <img :src="item.mainImgs"/>
                  </div>
                  <div class="bussinessGood_imgs_item_tetx">{{item.name}}</div>
                </div>
              </template>
            </div>
          </div>

          <div class="callme">
            <div class="introduction_title">
              <img class="titleIcon" src="../../../assets/img/web/icon.png"/>
              联系我们
            </div>
            <div class="callme_items">
              <div class="callme_item">
                <div class="callme_item_top">
                  <img class="texticon" src="../../../assets/img/web/gongsi.png"/>
                  <span style="font-size:16px;font-weight:bold;">公司地址：</span>
                </div>
                <div class="callme_item_bottom">{{ruleForm.address}}</div>
              </div>
              <div class="callme_item">
                <div class="callme_item_top">
                  <img class="texticon" src="../../../assets/img/web/dadianhua .png" alt/>
                  <span style="font-size:16px;font-weight:bold">联系电话：</span>
                </div>
                <div class="callme_item_bottom">{{ruleForm.phone}}</div>
              </div>
              <div class="callme_item">
                <div class="callme_item_top">
                  <img class="texticon" src="../../../assets/img/web/youxiang.png" alt/>
                  <span style="font-size:16px;font-weight:bold">邮箱：</span>
                </div>
                <div class="callme_item_bottom">{{ruleForm.email}}</div>
              </div>
              <div class="callme_item">
                <div class="callme_item_top">
                  <img class="texticon" src="../../../assets/img/web/qq.png"/>
                  <span style="font-size:16px;font-weight:bold">QQ：</span>
                </div>
                <div class="callme_item_bottom">{{ruleForm.qq}}</div>
              </div>
            </div>
          </div>

          <div class="footer">
            <div class="footer_item">
              <img src="../../../assets/img/web/mingpian.png"/>
              <div>名片</div>
            </div>
            <div class="footer_item">
              <img src="../../../assets/img/web/fangzi.png"/>
              <div>3D商城</div>
            </div>
            <div class="footer_item">
              <img src="../../../assets/img/web/dianshi.png"/>
              <div style="color:#8C7553">3D官网</div>
            </div>
          </div>
          -->
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      ruleForm: {
        type: Object,
        default: ""
      },
      Introduction: {
        type: String,
        default: ""
      },
      dataList: {
        type: Array,
        default: ''
      },
      arr: {
        type: Array,
        default: ''
      }
    },
    watch: {
      ruleForm: {
        handler: function (old, news) {
        },
        deep: true
      },
      dataList: {
        handler: function (old, news) {
          let show = false;
          for (let item of news) {
            if (item.id && item.mainImgs) {
              show = true
            }
          }
          this.itemShow = show;
        },
        deep: true
      },
    },
    data() {
      return {
        isShow: false,
        itemShow: true
      };
    }
  };
</script>

<style lang='less' scoped>
  .prdsadasdsa {
    height: 762px
  }

  .preview_phone {
    height: 863px;
    width: 431px;
    border-radius: 64px;
    position: relative;
  }

  .titleIcon {
    height: 17px;
    width: 17px;
  }

  .texticon {
    height: 15px;
    width: 15px;
    margin-right: 5px;
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
  }

  .footer_item {
    text-align: center;
  }

  .footer_item img {
    height: 20px;
    width: 20px;
  }

  .callme {
    height: 341px;
    margin-top: 10px;
    font-size: 14px;
    padding-bottom: 60px;
    background-color: #fff;
  }

  .callme_items {
    padding-left: 15px;
    height: 251px;
    width: 320px;
    color: #333;
  }

  .callme_item {
    margin-bottom: 25px;
  }

  .callme_item_top {
    line-height: 20px;
    margin-bottom: 5px;
  }

  .bussinessGood {
    height: 330px;
    width: 100%;
    background-color: #fff;
  }

  .bussinessGood_imgs {
    display: flex;
    height: 100%;
    overflow: hidden;
  }

  .bussinessGood_imgs_item img {
    height: 227px;
    width: 227px;
    margin-left: 15px;
  }

  .bussinessGood_imgs_item_tetx {
    text-align: center;
    margin-top: 15px;
    font-size: 14px;
    color: #333;
    margin-left: 15px;
  }

  .preview_phone_content {
    position: absolute;
    bottom: 25px;
    height: 720px;
    overflow: hidden;
    width: 374px;
    right: 28px;
    background-color: #f5f5f5;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
  }

  .introduction_text {
    line-height: 21px;
  }

  .preview_phone_content_img {
    width: 100%;
    height: 180px;
    margin-bottom: 10px;
  }

  .introduction {
    width: 100%;
    background: #fff;
    padding: 0px 10px 20px 10px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .introduction_title {
    font-size: 18px;
    padding-top: 15px;
    font-weight: bold;
    line-height: 18px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    margin-bottom: 20px;
  }

  .introductionUrl_img {
    width: 100%;
    height: 160px;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .introduction {
    font-size: 14px;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .entery_title {
    display: flex;
    margin-top: 30px;
    align-items: center;
    margin-bottom: 20px;

    .line {
      width: 3px;
      height: 19px;
      margin-right: 5px;
      background: rgba(102, 102, 102, 1);
    }

    .base_title {
      font-size: 18px;
      font-weight: bold;
      margin-right: 5px;
      color: rgba(51, 51, 51, 1);
    }

    .fuwenben {
      font-size: 14px;
      font-weight: 400;
      color: rgba(245, 108, 108, 1);
    }
  }
</style>
